// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"6f098492","278":"14cd61ba"}[chunkId] + ".chunk.js";
};